"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var getRandomIntFromRange_1 = __importDefault(require("./getRandomIntFromRange"));
var reservoirSample = function (array, maxSize) {
    if (array.length <= maxSize) {
        return array;
    }
    var newValueList = array.slice(0, maxSize);
    for (var i = maxSize; i < array.length; i++) {
        var nextIndex = getRandomIntFromRange_1["default"](0, i);
        if (nextIndex < maxSize) {
            newValueList[nextIndex] = array[i];
        }
    }
    return newValueList;
};
exports["default"] = reservoirSample;
//# sourceMappingURL=reservoirSample.js.map